import React from "react";
import { Text } from "react_reusable_components";
import { useIntl } from "react-intl";

import variables from "../../themes/base/styles/variables";
import { ThreeRow } from "../../core/layouts";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";

export const ErrorPageStyles = {
  errorPageStyle: {
    display: variables.dFlex,
    flexDirection: variables.flexDirection,
    justifyContent: variables.alignCenter,
    variables: variables.fullScreenHeight,
    backgroundColor: variables.lightGrey,
    color: variables.white1,
    fontFamily: variables.fontFamilyRegular,
    alignItems: variables.alignCenter,
  },
  errorHeader: {
    fontSize: variables.fontSizeheading3,
    fontWeight: variables.fontWeightBold,
    color: variables.textDefault,
  },
  errorMessage: {
    fontSize: variables.fontSizeXxlarge,
    color:variables.textDefault,
    fontWeight: variables.fontFamilyRegular,
  },
  errorImage: {
    marginBottom: variables.marginBottom,
    maxWidth: variables.errorIconWidth,
    objectFit: variables.objectFit,
  },
  threeRowStyle: {
    alignItems: variables.alignCenter,
  },
};

const ErrorPage = ({ errorMessage }) => {
  const intl=useIntl();

  return (
   
        <ThreeRow
          style={ErrorPageStyles.errorPageStyle}
          topSection={
            <img
              src={'/icons/Error.png'}
              alt="Error"
              style={ErrorPageStyles.errorImage}
            />
          }
          middleSection={
            <Text style={ErrorPageStyles.errorHeader}>
              {getLocalizedMessage(intl,"errorPage.header.value")}
            </Text>
          }
          bottomSection={
            <Text style={ErrorPageStyles.errorMessage}>{errorMessage || getLocalizedMessage(intl, "errorPage.routes.value")}</Text>
          }
        />
  );
};

export default ErrorPage;
